import { render, staticRenderFns } from "./IndexLegend.vue?vue&type=template&id=3bae6f79&scoped=true"
import script from "./IndexLegend.vue?vue&type=script&lang=js"
export * from "./IndexLegend.vue?vue&type=script&lang=js"
import style0 from "./IndexLegend.vue?vue&type=style&index=0&id=3bae6f79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae6f79",
  null
  
)

export default component.exports